import axios from "../_helpers/axiosInstance.js";
import {authHeader} from "../_helpers/authHeader.js";


const getWebOrderEstimate = async (taxAuthorityId, productType) => {
    const response = await axios.get(`webOrderEstimate?taxAuthorityId=${taxAuthorityId}&productType=${productType}`, {headers: authHeader()});
    return response.data.result;
}
export const webOrderEstimateApi = {
    getWebOrderEstimate,
}
